// GE-75 (Jordan 19.10) : prix ANNONCÉ au client à la création (calculateur
// complet) comparé au FACTURÉ (lignes privées figées), sur la fiche.
// → {texte, ecart} ; ecart = facturé − annoncé de l'issue retenue (sur
// place / transporté), null si incomparable (pas d'issue, devis, sous
// contrat). null sans annonce.
const chf = (n) =>
	Number.isInteger(Number(n)) ? `${Number(n)}` : Number(n).toFixed(2)

const prix = (p) => (p.devis ? "devis" : `${chf(p.total)}`)

export const annonceFacture = (annonce, facture) => {
	if (!annonce || !annonce.tr) return null
	if (annonce.sous_contrat)
		return {
			texte: `Annoncé : sous contrat (pas de tarif) · Facturé : ${chf(facture)} CHF`,
			ecart: null,
		}
	const annonces = annonce.sp
		? `sur place ${prix(annonce.sp)} / transporté ${prix(annonce.tr)}`
		: `transporté ${prix(annonce.tr)}`
	const retenu =
		annonce.issue === "SP"
			? annonce.sp
			: annonce.issue === "TR"
				? annonce.tr
				: null
	const ecart =
		retenu && !retenu.devis && retenu.total != null
			? Math.round((facture - retenu.total) * 100) / 100
			: null
	return {
		texte: `Annoncé : ${annonces} · Facturé : ${chf(facture)} CHF`,
		ecart: ecart && Math.abs(ecart) >= 0.01 ? ecart : null,
	}
}

export const texteEcart = (ecart) =>
	`écart ${ecart > 0 ? "+" : "−"}${chf(Math.abs(ecart))} CHF`
